import { PreloaderUtils } from '~components/Preloader/Preloader.utils';
import { env } from '~constants/env';

export const Preloader = PreloaderUtils.getPreloaderComponent(env.deployEnv);
